import { Component, ElementRef, OnInit } from '@angular/core';
import { MarketPlacePersonalizationUtils } from '@app-components/layouts/shopkeeper-layout/marketplace-personalization';
import { OpenService } from '@app-services/open.service';
import { Contact, LayoutVars } from '@app/store/session/session.store';

@Component({
  selector: 'app-session-layout',
  templateUrl: './session-layout.component.html'
})
export class SessionLayoutComponent implements OnInit {
  layoutVarsResponse: boolean;

  constructor(
    private openService: OpenService,
    private elRef: ElementRef
  ) { 
      this.openService.getLayoutVars()
        .subscribe(layoutVars => {
          MarketPlacePersonalizationUtils.initCssVars(this.elRef, layoutVars);
          if(layoutVars){
            this.contacts = layoutVars.contacts;
          }

          this.layoutVarsResponse = true
        });
    }

  contacts: Contact[];
  ngOnInit() {
  }

}
